import { render, staticRenderFns } from "./InicioView.vue?vue&type=template&id=38125ae3&scoped=true"
import script from "./InicioView.vue?vue&type=script&lang=js"
export * from "./InicioView.vue?vue&type=script&lang=js"
import style0 from "./InicioView.vue?vue&type=style&index=0&id=38125ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38125ae3",
  null
  
)

export default component.exports